
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'SectionTitle',
})
export default class SectionTitle extends Vue {
    @Prop({ type: Boolean, default: false }) public arrow!: boolean;
}
